@if (initialized && activeNavigationItem) {
    <div class="config-content-container surface-0">

        @switch (activeNavigationItem.action) {
            @case ('ac.AcTemplateAcquisitionCommission') {
                <div class="surface-0 border-round h-full">
                    <div class="grid h-full m-0">

                        <!-- Sidebar: Provisionsvorlagen (selectable) -->
                        <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                            @if (widgets?.templateAcquisitionCommissionSelectableWidget) {
                                <mvs-widget
                                        [widgetData]="widgets?.templateAcquisitionCommissionSelectableWidget.widgetData"
                                        (onObjectSelect)="onTemplateSelect($event)"
                                        (onObjectDeselect)="onTemplateDeselect()">
                                </mvs-widget>
                            }
                        </div>

                        <!-- Main Content: Provisionszuweisungen -->
                        <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                            @if (acAcquisitionCommissionAssignmentWidget) {
                                <mvs-widget
                                        [widgetData]="acAcquisitionCommissionAssignmentWidget">
                                </mvs-widget>
                            }
                        </div>

                    </div>
                </div>
            }
            @case ('ac.AcAgentCancellationBufferAssignment') {
                <div class="table-container scroll-table-container">
                    @if (widgets?.agentCancellationBufferAssignmentWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.agentCancellationBufferAssignmentWidget.widgetData">
                        </mvs-widget>
                    }
                </div>
            }
        }
    </div>
}
